import { HTTP } from '@/services/http'
import { Settings } from '@/settings'

export class InspectionService extends HTTP {
	constructor() {
		super(Settings.API_BASE_URL)
	}

	static inspectorsPromise = null
	static typesPromise = null
	static namaPromise = null
	static bikePromise = null

	async inspectors() {
		if (InspectionService.inspectorsPromise) {
			return await InspectionService.inspectorsPromise
		}

		InspectionService.inspectorsPromise = super.get('/inspectors')

		const res = await InspectionService.inspectorsPromise
		InspectionService.inspectorsPromise = null
		return res
	}

	async types() {
		if (InspectionService.typesPromise) {
			return await InspectionService.typesPromise
		}

		InspectionService.typesPromise = super.get('/inspectiontypes')

		const res = await InspectionService.typesPromise
		InspectionService.typesPromise = null
		return res
	}

	async list(motorvehicle_id) {
		return await super.get('/previousinspections', { motorvehicle_id })
	}

	async save(motorvehicle_id, inspectiontype_id, data, cache=true) {
		return await super.post('/saveinspection', {
			motorvehicle_id,
			inspectiontype_id,
			vehicle: JSON.stringify(data.vehicle),
			inspection: JSON.stringify(data.inspection),
		}, cache)
	}

	async namaGradeValues() {
		if (InspectionService.namaPromise) {
			return await InspectionService.namaPromise
		}

		InspectionService.namaPromise = super.get('/namagradevalues')

		const res = await InspectionService.namaPromise
		InspectionService.namaPromise = null
		return res
	}

	async bikeGradeValues() {
		if (InspectionService.bikePromise) {
			return await InspectionService.bikePromise
		}

		InspectionService.bikePromise = super.get('/bikegradevalues')

		const res = await InspectionService.bikePromise
		InspectionService.bikePromise = null
		return res
	}
}